import { render, staticRenderFns } from "./PlacanjeStatus.vue?vue&type=template&id=c75d6dce&"
import script from "./PlacanjeStatus.vue?vue&type=script&lang=js&"
export * from "./PlacanjeStatus.vue?vue&type=script&lang=js&"
import style0 from "./PlacanjeStatus.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports